import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  getAccessToken,
  logoutUser,
  clearAccessToken,
} from "../utils/fetchFunctions";
import { getUserRole } from "../utils/jwtUtils";
import "./navbar.css";

const Navbar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAccessToken();
    setIsLoggedIn(!!token);
    setUserRole(getUserRole());
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      const token = getAccessToken();
      setIsLoggedIn(!!token);
      setUserRole(getUserRole());
    };

    const interval = setInterval(checkAuth, 1000);
    window.addEventListener("focus", checkAuth);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", checkAuth);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await logoutUser();
      clearAccessToken();
      setIsLoggedIn(false);
      setIsMenuOpen(false);
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      clearAccessToken();
      setIsLoggedIn(false);
      setIsMenuOpen(false);
      navigate("/login");
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <button
        className="navbar__hamburger"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
      </button>
      <div className={`navbar__menu ${isMenuOpen ? "navbar__menu--open" : ""}`}>
        <div className="navbar__group navbar__group--left">
          <Link to="/" onClick={handleLinkClick}>
            Home
          </Link>
          <Link to="/fragenbogen" onClick={handleLinkClick}>
            Questionnaire
          </Link>
          {isLoggedIn && userRole === "admin" && (
            <Link to="/admin/dashboard" onClick={handleLinkClick}>
              Dashboard
            </Link>
          )}
          {isLoggedIn && userRole !== "admin" && (
            <Link to="/dashboard/overview" onClick={handleLinkClick}>
              Dashboard
            </Link>
          )}
        </div>
        <div className="navbar__group navbar__group--right">
          {isLoggedIn ? (
            <>
              <Link to="/profile" onClick={handleLinkClick}>
                Profile
              </Link>
              <button onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={handleLinkClick}>
                Login
              </Link>
              <Link to="/register" onClick={handleLinkClick}>
                Sign up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
